import AboutHeader from './AboutHeader';
import MeetTheStaff from "./MeetTheStaff"
import Description from './Description';
import Footer from '../../shared/Footer';

function AboutUs() {
  return (
    <>
      <AboutHeader />
      <MeetTheStaff />
      <Description />
      <Footer />
    </>

  )
}

export default AboutUs